/**
 * Единая точка выбора воркера pdf.js.
 *
 * ПОЧЕМУ ЛОКАЛЬНО, А НЕ С CDN: без воркера pdf.js не работает вовсе. Раньше просмотрщики
 * тянули его с cdnjs/unpkg, и это было терпимо — не открылся предпросмотр, не беда.
 * Но на воркере теперь держится ещё и КЛИЕНТСКОЕ СЖАТИЕ PDF: без него пользователь с
 * документом на 10-15 МБ вообще не сможет приложить файл, потому что несжатый он не
 * пролезает в тело запроса (лимит шлюза 10 МиБ). Зависеть в этом сценарии от внешнего
 * хоста нельзя, поэтому воркер лежит в `public/pdf.worker.min.js` и отдаётся с нашего же
 * домена.
 *
 * ПОЧЕМУ ОСТАЁТСЯ FALLBACK НА CDN: файл в public — статическая копия конкретной версии.
 * pdf.js отказывается работать, если версия воркера не совпадает с версией API
 * («The API version does not match the Worker version»), а версия приезжает транзитивно
 * через react-pdf. Если её обновят, а файл в public забудут заменить — молча сломался бы
 * и просмотр, и сжатие. Поэтому при несовпадении версий откатываемся на CDN: хуже, чем
 * локальный файл, но лучше, чем неработающая функция.
 *
 * ПРИ ОБНОВЛЕНИИ react-pdf / pdfjs-dist: заменить `public/pdf.worker.min.js` файлом
 * `build/pdf.worker.min.js` из пакета pdfjs-dist новой версии и поправить константу ниже.
 * Достать файл из PnP-кэша можно так (zip лежит в .yarn/cache):
 *   yarn unplug pdfjs-dist   — либо распаковать .yarn/cache/pdfjs-dist-npm-<version>-*.zip
 */

/** Версия pdfjs-dist, копия воркера которой лежит в public/pdf.worker.min.js. */
export const LOCAL_PDF_WORKER_VERSION = '3.11.174';

/** Путь к локальной копии воркера (public/ отдаётся из корня сайта). */
export const LOCAL_PDF_WORKER_SRC = '/pdf.worker.min.js';

/**
 * Возвращает адрес воркера под конкретную версию pdf.js.
 * @param version значение `pdfjs.version` из react-pdf
 */
export const getPdfWorkerSrc = (version: string): string =>
  version === LOCAL_PDF_WORKER_VERSION
    ? LOCAL_PDF_WORKER_SRC
    : `//unpkg.com/pdfjs-dist@${version}/build/pdf.worker.min.js`;
